import { render, staticRenderFns } from "./ArchiveOptions.vue?vue&type=template&id=1d854bff&"
import script from "./ArchiveOptions.vue?vue&type=script&lang=js&"
export * from "./ArchiveOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports